import { Line } from "react-chartjs-2";
import styles from "./ImageDetail.module.css";

const PriceHistoryBottomSection = ({ apiData }) => {
  const data = {
    labels: apiData.map((item) => item.gas),
    datasets: [
      {
        label: "Daily P&L",
        data: apiData.map((item) => item.gas),
        fill: true,
        tension: 0.5,
        borderColor: "#ec004f",
        backgroundColor: "#ec004f33",
      },
    ],
  };

  return (
    <div className="container-fluid p-3">
      <div className="row">
        {data.labels.length > 0 ? (
          <div className={`${styles.bottomSectionPrice} col-12`}>
            <div className={styles.bottomSectionPriceSingle}>
              <Line data={data} />
            </div>
          </div>
        ) : (
          <div className="text-center py-4">
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PriceHistoryBottomSection;
